import {dateFilters} from '../../constants/dateFilters';

class ColumnDefinition {

  constructor(props) {
    const isSetFilter = (filter) => filter === 'agSetColumnFilter';
    const usesApplyButton = (filter) => [
      'agSetColumnFilter',
      'agTextColumnFilter',
      'agNumberColumnFilter',
      'agDateColumnFilter'
    ].includes(filter);

    const getFilterOptionsForFilter = (filter) => {
      switch (filter) {
      case 'agDateColumnFilter':
        return dateFilters;      
      case 'agNumberColumnFilter':
          return ['equals', 'lessThan', 'greaterThan'];
      //case 'agBooleanColumnFilter':
      //  return ['equals'];
      default:
        return ['contains'];
      }
    };

    const filter = props.filter ? props.filter : 'agTextColumnFilter';

    const defFilterParams = {
      filter: filter,
      filterParams: {
        buttons: usesApplyButton(filter) ? ['reset', 'apply'] : ['reset'], 
        closeOnApply: usesApplyButton(filter),
        applyMiniFilterWhileTyping: !isSetFilter(filter),
        // Set filters here are backed by long, server-side value lists (e.g. every company),
        // and the chosen values are sent to the API as GET query params.
        //
        // excelMode: in AG Grid's default set-filter mode the search box only narrows what is
        // *displayed* -- the selection stays "everything" -- so "(Select All)" toggles the whole
        // value list and applying sends every value except the searched ones. Excel mode makes
        // the search box narrow the *selection* too, so "(Select All Search Results)" and Apply
        // act on the matches only. Our explicit buttons/closeOnApply above still win over its
        // defaults, and typing does not auto-apply while an apply button is present.
        //
        // defaultToNothingSelected: opening a filter starts empty and you pick what you want,
        // instead of starting fully selected where deselecting a few names sends thousands of
        // values (a URL long enough to break the request).
        ...(isSetFilter(filter) ? {excelMode: 'windows', defaultToNothingSelected: true} : {}),
        suppressAndOrCondition: true, 
        filterOptions: getFilterOptionsForFilter(filter),
        filterChanged: (params) => {
          console.log('when dropdown filter item changed');
          console.log(params);
        },

      },
    };

    if(props.comparator) {
      defFilterParams.filterParams.comparator = props.comparator;
    }
    if(props.filterValues) {
      defFilterParams.filterParams.values = props.filterValues;
    }

    //console.log('column generator props');
    //console.log(props);

    this.field = {
      flex: 1,
      resizable: true,
      sortable: props.sortable ? props.sortable : false,         // Thanh 02/04/24
      autoHeight: true,
      minWidth: props.width ? props.width : 200,
      maxWidth:  props.width ? props.width : null,
      field: props.parent ? `${props.parent}.${props.field.api_name}`:props.field.api_name,
      hide: props.hide,
      wrapText: props.wrapText,
      checkboxSelection: props.checkboxSelection,
      headerName: props.emptyHeader ? '' : props.headerName ? props.headerName?.toUpperCase() : props.field.label?.toUpperCase(),
      valueGetter: props.valueGetter,
      valueFormatter: props.valueFormatter,
      cellRendererParams: props.cellRendererParams ? props.cellRendererParams : {},
      floatingFilter: !props.removeDefaultFilter,
      //showWarning: props.showWarning,     // Thanh 05/01/24
      cellStyle: props.cellStyle ? props.cellStyle : {},
    };
    if(props.pinned) {
      this.field.pinned = props.pinned;
      this.field.lockPinned= props.lockPinned;
      this.field.lockPosition = true;
    }
    if(!props.removeDefaultFilter) {
      this.field = {...this.field, ...defFilterParams};
    }
    if(props.cellRenderer) {
      this.field.cellRenderer = props.cellRenderer;
    }
    if(props.comparator) {
      this.field.comparator = props.comparator;
    }
    if (props.convertToBoolean === true) {
      this.field.convertToBoolean = true;
    }
    if (typeof props.convertSetFilterValuesToApi === 'function') {
      this.field.convertSetFilterValuesToApi = props.convertSetFilterValuesToApi;
    }

    return this.field;
  }
}
export default ColumnDefinition;
